module.exports = __webpack_public_path__ + "img/bg_1.e656c574.png";